module.exports = __webpack_public_path__ + "static/media/wallet-connect.8ec0ff12.svg";